import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/elements/right-arrow.png")